import React, {useEffect, useState} from "react";
import {useHistory, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {_getUser, _resetPassword} from "../../store/user/service";
import {_getBanners, _getCountry, _getLang, _hideSpinner, _setCpToken, _showSpinner, _showModal, _hideModal, _getAdminLogin} from "../../store/system/service";
import {
    _cancelPolicy,
    _getPoliciesForUpdate,
    _getPolicyList,
    _removePolicyFromUpdate,
    _retrievePolicyList,
    _storePlanList,
    _storePolicy,
    _storeSubsidiaryList,
    _submitPolicy
} from "../../store/policy/service";
import usePortfolioStyles from "./portfolio-style";
import CorpPolicy from "./corp-policy";
import useConfig from "../qnect-ui/qnect-config";
import ConfirmChangeDialog from "./confirm-change-dialog";
import CancelChangeDialog from "./cancel-change-dialog";
import ScrollToTopButton from "../ui/scroll-to-top/scroll-to-top";
import Carousel from "../custom/carousel/carousel";
import ExpiredPasswordDialog from "./expired-password-dialog";


const Portfolio = props => {
    const cfg = useConfig(props.lang);
    const history = useHistory();
    const classes = usePortfolioStyles(props);
    const [openConfirmChangeDialog, setOpenConfirmChangeDialog] = useState(false);
    const [openCancelChangeDialog, setOpenCancelChangeDialog] = useState(false);
    const [openExpiredPasswordDialog, setOpenExpiredPasswordDialog] = useState(false);
    const [policyForUpdate, setPolicyForUpdate] = useState();
    const [submitMessage, setSubmitMessage] = useState([]);
    const [bannerList, setBannerList] = useState([]);
    const [isCarouselPlaying, setIsCarouselPlaying] = useState(false);
    const [passwordMinLength, setPasswordMinLength] = useState();
    const [passwordLimit, setPasswordLimit] = useState();

    useEffect(() => {
        if (props.policyList?.length === 0) {
            props.showSpinner();
            props.retrievePolicyList().then((response) =>  {
                console.log("RETRIEVE POLICY LIST TOKEN: " + response.data.token);
                props.setCpToken(response.data.token);
                props.hideSpinner()
                setIsCarouselPlaying(true);
                if(response.data.isPasswordExpired) {
                     setOpenExpiredPasswordDialog(true);
                     setPasswordMinLength(response.data.passwordMinLength);
                     setPasswordLimit(response.data.passwordLimit);
                }
            });
          }
        setSubmitMessage([]);

    },[]);

    useEffect(() => {
        props.getBanners().then((response) =>  {
            setBannerList(response);
        });
    },[props.cpToken]);

    const submitPolicy = (policyNumber) => {
        if (props.policiesForUpdate && policyNumber) {
            let found = props.policiesForUpdate.find((p) => {
                return p.policyNumber === policyNumber
            });

            console.log("Prepare submitting policy " + policyNumber, found);
            setPolicyForUpdate(found);
        }
        setOpenConfirmChangeDialog(true);
        setSubmitMessage([]);
    }

    const submitPolicyConfirm = () => {
        if (policyForUpdate) {
            props.showSpinner();
            setSubmitMessage([]);
            props.submitPolicy(policyForUpdate).then((response) => {
                if (response.success) {
                    let msg =  {
                        policyNumber: policyForUpdate.policyNumber,
                        type: 'INFO',
                        message: cfg('labels.submitSuccess') + ' Submission Request Number ' + response.submissionId
                    };
                    setSubmitMessage(submitMessage => [...submitMessage, msg]);
                    // remove the request
                    props.removePolicyFromUpdate(policyForUpdate.policyNumber);
                    setPolicyForUpdate(null);
                    props.hideSpinner();
                    setOpenConfirmChangeDialog(false);
                }
                else {
                    let msg =  {
                        policyNumber: policyForUpdate.policyNumber,
                        type: 'ERROR',
                        message: cfg('labels.submitFailure')
                    };
                    setSubmitMessage(submitMessage => [...submitMessage, msg]);
                    props.hideSpinner();
                    setOpenConfirmChangeDialog(false);
                }
            }, (error) => {
                console.log('submitPolicy failed', error);
                let msg =  {
                    policyNumber: policyForUpdate.policyNumber,
                    type: 'ERROR',
                    message: cfg('labels.submitFailure')
                };
                setSubmitMessage(submitMessage => [...submitMessage, msg]);
                props.hideSpinner();
                setOpenConfirmChangeDialog(false);
            })

        }
    }

    const cancelPolicy = (policyNumber) => {
        if (props.policiesForUpdate && policyNumber) {
            let found = props.policiesForUpdate.find((p) => {
                return p.policyNumber === policyNumber
            });

            console.log("Prepare cancelPolicy " + policyNumber, found);
            setPolicyForUpdate(found);
        }
        setOpenCancelChangeDialog(true);
    }

    const cancelPolicyConfirm = () => {
        if (policyForUpdate) {
            props.cancelPolicy(policyForUpdate.policyNumber);
            setPolicyForUpdate(null);
        }
        setOpenCancelChangeDialog(false);
    }

    const canSubmit = (policyNumber) => {
        if (props.policiesForUpdate && policyNumber) {
            let found = props.policiesForUpdate.find((p) => { return p.policyNumber === policyNumber });
            return found?.members?.length > 0 ? true : false;
        }
        return false;
    }

    const getSubmitMessage = (policyNumber) => {
        return submitMessage?.find((p) => {
            return p.policyNumber === policyNumber
        });
    }


    return (
        <div style={{overflowY: "auto !important"}}>
            {/* HEADER - START */}
            {bannerList && bannerList.length > 0 && <Carousel bannerList={bannerList} isPlaying={isCarouselPlaying}/>}
            <div className={classes.portfolio_container}>
                <div className={classes.portfolio_title}>
                    <h2>Policies</h2>
                </div>
                {/* HEADER - END */}

                <div>
                    {
                        props.policyList.map((policy, index) => {
                            return <CorpPolicy policy={policy} policyIndex={index} key={'policy'+index}
                                               canSubmit={canSubmit(policy.policyNumber)}
                                               onSubmit={() => submitPolicy(policy.policyNumber)}
                                               onCancel={() => cancelPolicy(policy.policyNumber)}
                                               submitMessage={getSubmitMessage(policy.policyNumber)}
                                               props={props} cfg={cfg}></CorpPolicy>
                        })
                    }
                </div>
                <ConfirmChangeDialog open={openConfirmChangeDialog}
                                    onClose={() => setOpenConfirmChangeDialog(false)}
                                    onOk={() => submitPolicyConfirm()}
                                    policy={policyForUpdate}>
                </ConfirmChangeDialog>

                <CancelChangeDialog open={openCancelChangeDialog}
                                    onClose={() => setOpenCancelChangeDialog(false)}
                                    onOk ={() => cancelPolicyConfirm()}
                                    policy={policyForUpdate}>
                </CancelChangeDialog>

                <ExpiredPasswordDialog open={openExpiredPasswordDialog}
                                    props={props}
                                    passwordMinLength={passwordMinLength}
                                    passwordLimit={passwordLimit}>
                </ExpiredPasswordDialog>
                <ScrollToTopButton></ScrollToTopButton>

            </div>
        </div>
    );
};


const mapStateToProps = (state) => {
    return {
        country: _getCountry(state),
        user: _getUser(state),
        lang: _getLang(state),
        policiesForUpdate: _getPoliciesForUpdate(state),
        policyList: _getPolicyList(state),
        adminLogin: _getAdminLogin(state)
    };
}

const mapDispatchToProps = {
    retrievePolicyList: _retrievePolicyList,
    storePolicy: _storePolicy,
    storeSubsidiaryList: _storeSubsidiaryList,
    storePlanList: _storePlanList,
    submitPolicy: _submitPolicy,
    cancelPolicy: _cancelPolicy,
    removePolicyFromUpdate: _removePolicyFromUpdate,
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    setCpToken: _setCpToken,
    getBanners: _getBanners,
    resetPassword: _resetPassword,
    showModal: _showModal,
    hideModal: _hideModal
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Portfolio));
